import z from 'zod';

import { MatchingRecord } from '@eluve/utils';

import {
  TranscriptCancellationReasonEnum,
  TranscriptTypesEnum,
  TranscriptionStatusEnum,
} from './types';

export const TranscriptTypesLookup = {
  BATCH: 'BATCH',
  LIVE: 'LIVE',
  CHUNKED_BATCH: 'CHUNKED_BATCH',
} as const satisfies MatchingRecord<TranscriptTypesEnum>;

export const TranscriptStatusLookup = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
  PENDING_AUDIO: 'PENDING_AUDIO',
  PRE_PROVISIONED: 'PRE_PROVISIONED',
  CANCELLED: 'CANCELLED',
} as const satisfies MatchingRecord<TranscriptionStatusEnum>;

export const TranscriptCancellationReasonLookup = {
  ZERO_BYTE_AUDIO_FILE: 'ZERO_BYTE_AUDIO_FILE',
  DEGRADED_AUDIO_FILE: 'DEGRADED_AUDIO_FILE',
  PHANTOM_SLOT: 'PHANTOM_SLOT',
  EMPTY_DECLARED: 'EMPTY_DECLARED',
  MANUAL_OVERRIDE: 'MANUAL_OVERRIDE',
  SUPERSEDED_BY_DEGRADED_BACKUP: 'SUPERSEDED_BY_DEGRADED_BACKUP',
} as const satisfies MatchingRecord<TranscriptCancellationReasonEnum>;

export const TranscriptTypeSchema = z.nativeEnum(TranscriptTypesLookup);
